import fetch from '@/common/js/http';


const holidayConfig = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        getAllConfig({commit}) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'holidayConfig/all',
                    method: 'get',
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },
        saveConfig({commit}, data) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'holidayConfig',
                    method: 'post',
                    data: data
                }).then(success => {
                    resolve(success)
                }, error => {
                    reject(error)
                })
            })
        },


    }
}
export default holidayConfig




// WEBPACK FOOTER //
// ./src/vuex/modules/holidayConfig.js